module.exports = __webpack_public_path__ + "img/mastercard-old.21ed4054.svg";